<template>
  <div class="contacts">
    <va-page-header>

      <div slot="title">
        <span>Manage contacts</span>

      </div>

      <div slot="actions">
        <!-- <va-button style="position: absolute; right: 22px; top: 70px;" type="primary" @click.native="navigate('/survey')">New Survey</va-button> -->

        <va-button @click.native="showAddContactsModal" style="position: absolute; right: 22px; top: 70px;" type="primary" size="lg">ADD contacts</va-button>
      </div>

    </va-page-header>

    <va-form ref="formFilter" type="inline" style="justify-content:center; margin-top:-10px;">

      <!-- <va-form-item label="Reference"> -->
      <va-radio-group v-model="filterType" :rules="[{type:'required'}]" style="margin-right:14px;">
        <va-radio-btn label="team">Team</va-radio-btn>
        <va-radio-btn label="nazer">Nazireen</va-radio-btn>
        <va-radio-btn label="voter">Voters</va-radio-btn>
      </va-radio-group>
      <va-select :options="provinces" placeholder="Select Province" v-model="filterProvince" :rules="[{type:'required'}]" type="subtle">
      </va-select>
      <!-- </va-form-item>
      <va-form-item label="Reference"> -->

      <!-- </va-form-item> -->
    </va-form>

    <va-table v-if="contacts !== null" :hover="true" :full-width="true" class="datatable">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Province</th>
            <th>Phone</th>
            <th>Reference</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="contact in contacts" style="height:38px">
            <td>
              <!-- {{survey.name}} -->
              <!-- <va-button type="link" @click.native="navigate('/survey/' + survey.id)">{{ survey.name }}</va-button> -->
              <a style="cursor:pointer" @click="navigate('/contacts/' + contact.id)">{{contact.name}}</a>
            </td>
            <td>{{ contact.province }} - {{ contact.district }}</td>
            <td>{{ contact.phone }}</td>
            <td>{{ contact.reference }}</td>

            <td>
              <va-dropdown>
                <div slot="trigger">
                  <va-icon type="ellipsis-h" margin="0 0 0 7px"></va-icon>
                </div>
                <li>
                  <a href="#" v-if="contact.status == 'running'">Stop</a>
                </li>
                <li>
                  <a href="#" v-if="contact.status == 'running' || contact.status == 'completed' ">Results</a>
                </li>
                <li>
                  <a href="#" v-if="contact.status == 'new'">Publish</a>
                </li>
                <li>

                  <a @click="deleteContact(contact.id)">Delete</a>
                </li>
              </va-dropdown>
            </td>

          </tr>
        </tbody>
      </table>
    </va-table>

    <loader v-else-if="loading" />

    <div v-else :class="$style.deadCenter">
      <p>No contacts available</p>
      <br>
      <va-button type="primary" @click.native="navigate('/survey')">New Survey</va-button>
    </div>

    <!-- <loader v-if="loading" /> -->

    <va-modal title="Add Contacts" :width="450" ref="addContactsModal" :backdrop-clickable="false" @confirm="addContacts" style="zoom:1.2">
      <div slot="body">
        <va-form ref="addContactsForm" type="horizontal">
          <va-form-item label="Name">
            <va-input name="name" v-model="contactsForm.name" placeholder="Full name" :rules="[{type:'required'}]" show-clean />
          </va-form-item>
          <va-form-item label="Phone">
            <va-input name="phone" v-model="contactsForm.phone" placeholder="Phone number" :rules="[{type:'required'}]" show-clean />
          </va-form-item>
          <va-form-item label="Type">
            <!-- <va-select type="paleblue" placeholder="Choose one" v-model="contactsForm.type" :rules="[{type:'required'}]">
              <va-option value="campaigner">Campaigner</va-option>
              <va-option value="nazer">Nazer</va-option>
              <va-option value="voter">Voter</va-option>
            </va-select> -->
            <va-radio-group v-model="contactsForm.type" :rules="[{type:'required'}]">
              <va-radio label="team">Team</va-radio>
              <va-radio label="nazer">Nazer</va-radio>
              <va-radio label="voter">Voter</va-radio>
            </va-radio-group>
          </va-form-item>
          <div v-if="contactsForm.type!='' && contactsForm.type!=null">
            <va-form-item label="Province">
              <va-select :options="provinces" v-model="province" placeholder="Select a province" :rules="[{type:'required'}]" no-uncheck
              />
            </va-form-item>
            <va-form-item label="District">
              <va-select :options="districts" v-model="district" placeholder="Select a district" :rules="[{type:'required'}]" no-uncheck
              />
            </va-form-item>
            <div v-if="contactsForm.type!='team'">
              <va-form-item label="PC Location">
                <va-select :options="pc_locations" v-model="pc_location" placeholder="Select polling center location" :rules="[{type:'required'}]"
                  no-uncheck />
              </va-form-item>

              <va-form-item label="Polling Center">
                <va-select :options="pcs" v-model="pc" placeholder="Select a polling center" :rules="[{type:'required'}]" no-uncheck />
              </va-form-item>

              <va-form-item label="Sticker Number">
                <va-input name="reg_number" v-model="contactsForm.reg_number" placeholder="Voter registration number" show-clean />
              </va-form-item>

            </div>
            <va-form-item label="Reference">
              <!-- <contacts-input v-model="ref1" :rules="[{type:'required'}]" placeholder="Contact reference" /> -->
              <va-typeahead v-model="contactsForm.reference" :show-clean="true" :debounce="100" placeholder="Contact reference" @change="getReferences"
                :items="references" :item-render="renderItem" :add-format="itemSelected" ref="typeAhead" icon="user" :limit="10">
              </va-typeahead>
            </va-form-item>
          </div>
        </va-form>
      </div>
    </va-modal>
  </div>
</template>

<script>
  // @ is an alias to /src
  import {
    mapGetters,
    mapActions
  } from "vuex";
  import loader from "@/components/Loader";
  export default {
    name: "home",
    data() {
      return {
        loading: true,
        contacts: null,
        references: [],
        provinces: [],
        districts: [],
        pc_locations: [],
        pcs: [],
        pc_location: '',
        province: '',
        pc: '',
        district: '',
        contactsForm: {
          name: '',
          phone: '',
          type: '',
          pc_name: '',
          reg_number: '',
          reference: '',
          reference_id: ''
        },
        filterProvince: '',
        filterType: 'team'
      };
    },
    components: {
      loader
    },
    computed: {
      // ...mapGetters(["getSurveys "])
    },
    watch: {
      ref1(vv) {
        console.log(vv);
      },
      filterType(t) {
        this.loading = true;
        this.loadContacts();
      },
      filterProvince(p) {
        this.loading = true;
        this.loadContacts();
      },
      province(p) {
        if (p !== null) {
          this.loading = true;
          var districts = [];
          var districtsRef = db.collection("districts");
          if (districtsRef !== null) {
            let prov_id = p.split("_")[0];
            districtsRef.where("province_id", '==', prov_id * 1).get().then(snap => {
              districts = [];
              snap.forEach(doc => {
                districts.push({
                  value: doc.id,
                  label: doc.data().name,
                  district_id: doc.data().district_id
                  // id: doc.id,
                  // ...doc.data()
                });
              });
              // this.$store.commit("updatedistricts", districts);
              districts = districts.sort((a, b) => a.value - b.value);
              let d = [];
              districts.forEach(item => {
                d.push({
                  value: item.value + '_' + item.label + '_' + item.district_id,
                  label: item.label
                });
              });
              this.districts = d;
              this.district = null;
              // console.log(this.districts);
              this.loading = false;
              // setTimeout(() => this.loading = false, 2000);
            });
          }
        }
      },
      district(d) {
        if (d !== null) {
          this.loading = true;
          var pc_locations = [];
          var pc_locationsRef = db.collection("pcs");
          if (pc_locationsRef !== null) {
            let prov_id = this.province.split("_")[0];
            let dist_id = this.district.split("_")[1];
            let pc_start = prov_id.padStart(2, "0") + dist_id.padStart(2, "0");
            console.log("prov_id, dist_id: ", prov_id, dist_id);
            // console.log("pc start: ", pc_start);
            pc_locationsRef.where("province_id", '==', prov_id.padStart(2, "0")).where("district", '==', dist_id).get()
              .then(
                snap => {
                  pc_locations = [];
                  snap.forEach(doc => {
                    pc_locations.push({
                      value: doc.data().pc_location,
                      label: doc.data().pc_location,
                    });
                  });
                  pc_locations = pc_locations.filter((obj, pos, arr) => arr.map(mapObj => mapObj["label"].trimEnd()).indexOf(
                    obj[
                      "label"].trimEnd()) === pos);
                  this.pc_locations = pc_locations;
                  this.pcs = [];
                  this.pc_location = null;
                  // console.log(this.districts);
                  this.loading = false;
                  // setTimeout(() => this.loading = false, 2000);
                });
          }
        }
      },
      pc_location(p) {
        if (p !== null) {
          this.loading = true;
          var pcs = [];
          var pcsRef = db.collection("pcs");
          if (pcsRef !== null) {
            let prov_id = this.province.split("_")[0];
            let dist_id = this.district.split("_")[1];
            console.log(p);
            pcsRef.where("province_id", '==', prov_id.padStart(2, "0")).where("district", '==', dist_id)
              .where("pc_location", '==', p).get().then(snap => {
                pcs = [];
                snap.forEach(doc => {
                  pcs.push({
                    value: doc.id + '_' + doc.data().pc_name,
                    label: doc.data().pc_name,
                  });
                });
                // pcs = pcs.filter((pcs, index, self) => self.findIndex(t => t.label === pcs.label) === index);
                // pcs = pcs.filter((pcs, index, self) => self.findIndex(t => t.place === thing.place && t.name === thing.name) === index)
                this.pcs = pcs;
                this.pc = null;
                // console.log(this.districts);
                this.loading = false;
                // setTimeout(() => this.loading = false, 2000);
              });
          }
        }
      }
    },
    methods: {
      // ...mapActions(["fetchSurveys "]),
      navigate(to) {
        this.$router.push(to);
      },
      showAddContactsModal() {
        this.contactsForm = {
          name: '',
          phone: '',
          type: this.filterType,
          pc_name: '',
          pc: '',
          pc_location: '',
          reg_number: '',
          reference: '',
          reference_id: ''
        }
        // console.log(this.districts);
        this.province = null;
        this.district = null;
        this.pc_location = null;
        this.pc = '';
        this.districts = [];
        this.pc_locations = [];
        this.pcs = [];
        this.$refs.addContactsForm.validate = false;
        this.$refs.addContactsModal.open()
      },
      addContacts() {
        //console.log(this.$refs.addContactsForm);
        this.$refs.addContactsForm.validateFields((result) => {
          if (result.isvalid) {
            console.log("isvalid:", result.isvalid);
            var contactsRef = db.collection("contacts");
            if (contactsRef !== null) {
              let newRec = { ...this.contactsForm,
                province_id: this.province.split("_")[0],
                district_id: this.district.split("_")[0],
                province: this.province.split("_")[1],
                district: this.district.split("_")[1],
              }
              if (this.contactsForm.type != '' && this.contactsForm.type != 'team')
                newRec = { ...newRec,
                  pc: this.pc.split("_")[0],
                  pc_location: this.pc_location,
                  pc_name: this.pc.split("_")[1]
                }
              contactsRef.add(newRec).then(doc => {
                  this.loadContacts();
                  this.$refs.addContactsModal.close();
                })
                .catch(error => {
                  console.error("Error adding document: ", error);
                  alert(error.message);
                });
            }
          }
        })
      },
      deleteContact(id) {
        let vmm = this;
        this.loading = true;
        this.VaModal.alert({
          title: 'Are you sure!',
          message: 'Are you sure you want to delete this contact?',
          type: "danger",
          width: 500,
          onConfirm() {
            db.collection("contacts").doc(id).delete().then(() => {
              vmm.loadContacts();
              vmm.loading = false;
            });
          }
        })
      },
      loadContacts() {
        var contacts = [];
        this.contacts = null;
        this.loading = true;
        let prov = this.filterProvince.split("_")[1] || '';
        var contactsRef = db.collection("contacts");
        if (contactsRef !== null) {
          contactsRef
            .where("type", "==", this.filterType)
            .where("province", ">=", prov)
            .where("province", "<=", prov + '\uf8ff')
            .get().then(snap => {
              contacts = [];
              snap.forEach(doc => {
                contacts.push({
                  id: doc.id,
                  ...doc.data()
                });
              });
              // this.$store.commit("updatecontacts ", contacts);
              this.contacts = contacts.sort((a, b) => a.id - b.id);
              this.loading = false;
              // setTimeout(() => this.loading = false, 2000);
              // [FGEKX1006].DBO.[OSLTM_LOCAL_ENVIRONMENT] with key 0 was not found
            });
        }
      },
      getReferences: function (q) {
        db.collection("contacts").orderBy("name").limit(10).startAt(q).endAt(q + '\uf8ff').get().then(snap => {
          let contacts = [];
          snap.forEach(doc => contacts.push({ ...doc.data(),
            id: doc.id
          }));
          this.references = contacts;
        });
      },
      renderItem(item) {
        return `<div style="cursor:default;">
                <div style="">${item.name}</div>
                <span style="font-size:0.7em;opacity:0.8">${item.province} - ${item.district} </span>
              </div>`
      },
      itemSelected(item) {
        this.contactsForm.reference_id = item.id;
        return item.name;
      }
    },
    mounted() {
      this.loadContacts("team");
      var provinces = [];
      var provincesRef = db.collection("provinces");
      if (provincesRef !== null) {
        provincesRef.get().then(snap => {
          provinces = [];
          snap.forEach(doc => {
            provinces.push({
              value: doc.id,
              label: doc.data().name_ps,
              // id: doc.id,
              // ...doc.data()
            });
          });
          // this.$store.commit("updateprovinces", provinces);
          provinces = provinces.sort((a, b) => a.value - b.value);
          let p = [];
          provinces.forEach(item => {
            p.push({
              value: item.value + '_' + item.label,
              label: item.label
            });
          });
          this.provinces = p;
          this.loading = false;
          // setTimeout(() => this.loading = false, 2000);
        });
      }
    }
  };
</script>

<style module>
</style>